import React from 'react'
import './SortInfo.css'
export default function SelectionSort() {
  return (
    <div>
      <div className='sort-info'>
      <div className="sort-name">
          Name : Selection Sort
        </div>
        <div className="sort-time">
          Time Complexity : O(n<sup>2</sup>)
        </div>
    </div>
    </div>
  )
}
